import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './services.css';
import Footer from '../Footer';
import {
    FaLaptopCode,
    FaCogs,
    FaMobileAlt,
    FaGlobe,
    FaChartBar,
    FaNetworkWired,
    FaServer,
    FaLaptop,
    FaMicrochip,
    FaCar,
    FaCloud,
    FaIndustry
} from 'react-icons/fa';
import HiringIcon from '../HiringIcon/hiring';
import GoToTop from '../GoToTop/GoToTop';

function Services() {
    const [activeService, setActiveService] = useState('customSoftware');
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const serviceId = location.hash.replace('#', '');
            setActiveService(serviceId);
            const element = document.querySelector('.serviceMainSection');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    const servicesData = [
        {
            id: 'customSoftware',
            title: 'Custom Software Development',
            subtitle: 'Scalable Digital Solutions',
            icon: <FaLaptopCode />,
            content: (
                <>
                    <h4>Custom Software Development</h4>
                    <p>As a professional custom software development company, we design and build tailor-made applications aligned with your business processes. Our solutions are engineered for scalability, security, and long-term growth, helping organizations automate operations and improve efficiency.</p>
                    <ul>
                        <li>Enterprise software solutions</li>
                        <li>Business process automation systems</li>
                        <li>API development & system integration</li>
                        <li>Scalable architecture design</li>
                    </ul>
                </>
            )
        },
        {
            id: 'erpSaas',
            title: 'ERP & SaaS Solutions',
            subtitle: 'Enterprise Process Automation',
            icon: <FaCogs />,
            content: (
                <>
                    <h4>ERP & SaaS Solutions</h4>
                    <p>We develop powerful ERP systems and SaaS platforms that streamline operations, centralize data, and enable real-time decision-making. Our cloud-based and enterprise ERP solutions are designed for flexibility, performance, and sustainable growth.</p>
                    <ul>
                        <li>Custom ERP development</li>
                        <li>Multi-tenant SaaS platforms</li>
                        <li>Subscription-based software systems</li>
                        <li>Workflow automation & reporting dashboards</li>
                    </ul>
                </>
            )
        },
        {
            id: 'mobileApp',
            title: 'Mobile Application Development',
            subtitle: 'Android & iOS Apps',
            icon: <FaMobileAlt />,
            content: (
                <>
                    <h4>Mobile Application Development</h4>
                    <p>We build high-performance Android and iOS applications with intuitive UI/UX design and seamless functionality. As a full-cycle mobile app development company, we deliver scalable and secure applications for enterprises and startups.</p>
                    <ul>
                        <li>Native and cross-platform app development</li>
                        <li>Enterprise mobility solutions</li>
                        <li>App UI/UX design</li>
                        <li>App maintenance & optimization</li>
                    </ul>
                </>
            )
        },
        {
            id: 'webApp',
            title: 'Web Application Development',
            subtitle: 'Secure & Scalable Web Apps',
            icon: <FaGlobe />,
            content: (
                <>
                    <h4>Web Application Development</h4>
                    <p>Our team develops secure, responsive, and high-performing web applications tailored to your business requirements. We focus on scalability, cross-browser compatibility, and user-centric design to deliver powerful digital experiences.</p>
                    <ul>
                        <li>Custom web app development</li>
                        <li>Portal & dashboard systems</li>
                        <li>Progressive web applications (PWA)</li>
                        <li>Secure backend development</li>
                    </ul>
                </>
            )
        },
        {
            id: 'powerBI',
            title: 'Power BI & Advanced Analytics',
            subtitle: 'Data Driven Insights',
            icon: <FaChartBar />,
            content: (
                <>
                    <h4>Power BI & Advanced Analytics</h4>
                    <p>We transform raw data into actionable insights through advanced analytics and interactive dashboards. Our Power BI and Business Intelligence solutions help organizations track KPIs, analyze trends, and make data-driven decisions.</p>
                    <ul>
                        <li>Business intelligence dashboards</li>
                        <li>Data visualization & reporting</li>
                        <li>Performance monitoring systems</li>
                        <li>Predictive analytics</li>
                    </ul>
                </>
            )
        },
        {
            id: 'iotSolutions',
            title: 'IoT Solutions',
            subtitle: 'Connected Smart Systems',
            icon: <FaNetworkWired />,
            content: (
                <>
                    <h4>IoT Solutions</h4>
                    <p>We deliver end-to-end IoT development services by integrating hardware, firmware, and software systems. Our smart solutions enable real-time monitoring, automation, and connected device ecosystems across industries.</p>
                    <ul>
                        <li>Smart device integration</li>
                        <li>Industrial IoT solutions</li>
                        <li>Real-time monitoring systems</li>
                        <li>Sensor & data communication platforms</li>
                    </ul>
                </>
            )
        },
        {
            id: 'cloudInfra',
            title: 'Cloud & On-Premise Infrastructure',
            subtitle: 'Secure Scalable Environments',
            icon: <FaServer />,
            content: (
                <>
                    <h4>Cloud & On-Premise Infrastructure</h4>
                    <p>We provide secure cloud-native and on-premise infrastructure solutions designed for high availability and scalability. From server setup to cloud migration and maintenance, we ensure optimal system performance.</p>
                    <ul>
                        <li>Cloud deployment & migration</li>
                        <li>Server architecture design</li>
                        <li>DevOps & CI/CD implementation</li>
                        <li>Infrastructure monitoring & security</li>
                    </ul>
                </>
            )
        },
        {
            id: 'websiteDev',
            title: 'Website Development',
            subtitle: 'Modern SEO Optimized Websites',
            icon: <FaLaptop />,
            content: (
                <>
                    <h4>Website Development</h4>
                    <p>We design modern, responsive, and SEO-optimized websites that strengthen your digital presence. From corporate websites to dynamic business platforms, we create performance-driven websites that generate leads and drive engagement.</p>
                    <ul>
                        <li>Corporate website development</li>
                        <li>E-commerce platforms</li>
                        <li>SEO-friendly web design</li>
                        <li>Website maintenance & optimization</li>
                    </ul>
                </>
            )
        },
        {
            id: 'embedded',
            title: 'Embedded Software Development Services',
            subtitle: 'Shaping the Ubiquitous Face of Technology',
            icon: <FaMicrochip />,
            content: (
                <>
                    <h4>Embedded Software Development Services: <br />Shaping the Ubiquitous Face of Technology</h4>
                    <p>We deliver cost-effective, end-to-end embedded solutions for modern connected technologies, developing advanced systems and integrating devices with cloud platforms for smart, scalable operations. With deep expertise across leading chipsets and industries, we design reliable architectures tailored to your business needs.</p>
                    <ul>
                        <li>End-to-end embedded solutions for connected devices</li>
                        <li>Cloud integration for smart and scalable operations</li>
                        <li>Expertise in SoCs & microcontrollers: DA14585, DA14695, nRF52832, ESP32</li>
                        <li>Solutions for eMobility, Healthcare, and Home Automation</li>
                        <li>Experience with Renesas, Dialog, Arm, Nordic Semiconductor, STMicroelectronics</li>
                        <li>Custom architectures aligned with business requirements</li>
                        <li>Reliable delivery with flexible global collaboration</li>
                    </ul>
                </>
            )
        },
        {
            id: 'electricVehicle',
            title: 'eMobility',
            subtitle: 'Ecological Contribution to Save the Environment',
            icon: <FaCar />,
            content: (
                <>
                    <h4>eMobility: Aiding eMobility Businesses across the World</h4>
                    <p>We support eMobility businesses with intelligent software, mobility solutions, and system integrations that enable efficient, connected, and sustainable transportation. Our technology helps manufacturers and mobility providers build smarter, reliable, and future-ready electric mobility solutions.</p>
                    <ul>
                        <li>End-to-end embedded solutions for connected devices</li>
                        <li>Cloud integration for smart and scalable operations</li>
                        <li>Expertise in SoCs & microcontrollers: DA14585, DA14695, nRF52832, ESP32</li>
                        <li>Solutions for eMobility, Healthcare, and Home Automation</li>
                        <li>Experience with Renesas, Dialog, Arm, Nordic Semiconductor, STMicroelectronics</li>
                        <li>Custom architectures aligned with business requirements</li>
                        <li>Reliable delivery with flexible global collaboration</li>
                    </ul>
                </>
            )
        },
        {
            id: 'cloudComputing',
            title: 'Cloud Computing Services',
            subtitle: 'The Ultimate Future of Technology',
            icon: <FaCloud />,
            content: (
                <>
                    <h4>Cloud Computing Services: The Ultimate Future of Technology</h4>
                    <p>We provide secure, scalable, and cost-efficient cloud computing solutions that help businesses optimize performance, reduce costs, and innovate faster.</p>
                    <ul>
                        <li>Elastic and scalable cloud infrastructure for business growth</li>
                        <li>Workload optimization to improve efficiency and performance</li>
                        <li>Pay-as-you-use model to control and reduce operational costs</li>
                        <li>Secure cloud environments with high reliability</li>
                        <li>Rapid deployment, updates, and seamless system integration</li>
                        <li>Flexibility to innovate, test, and launch new features quickly</li>
                        <li>Efficient handling of peak workloads and operational fluctuations</li>
                    </ul>
                </>
            )
        },
        {
            id: 'industry40',
            title: 'Industry 4.0',
            subtitle: 'Embracing the Technological Revolution',
            icon: <FaIndustry />,
            content: (
                <>
                    <h4>Industry 4.0: Embracing the Technological Revolution</h4>
                    <p>We help businesses embrace Industry 4.0 by integrating smart technologies that enhance manufacturing efficiency, operational agility, and product quality.</p>
                    <ul className="embedded-services-list">
                        <li>Smart manufacturing and process automation solutions</li>
                        <li>Integration of IT with engineering, production, and quality systems</li>
                        <li>Improved operational agility and flexibility</li>
                        <li>Data-driven insights for better decision-making</li>
                        <li>Enhanced production efficiency and output quality</li>
                        <li>Scalable solutions to support growth and revenue expansion</li>
                        <li>Optimized supply chain and distribution processes</li>
                    </ul>
                </>
            )
        }
    ];

    const activeServiceData = servicesData.find(s => s.id === activeService);

    return (
        <div>
            <Helmet>
                <title>Services - KibbCom.com</title>
                <meta name="description" content="Trusted technology partner delivering end-to-end, secure, and scalable software solutions tailored to modern business needs." />
            </Helmet>
            <div className='serviceBannerImage'>
                <div className='serviceBannerContent'>
                    <h1 className='mb-4'>From Strategy <br />to Execution </h1>
                    <p>Trusted technology partner delivering end-to-end, secure, and scalable software solutions tailored to modern business needs.</p>
                </div>
            </div>

            <section className='serviceMainSection py-5'>
                <Container>
                    <div className='row'>
                        <div className='col-lg-4 col-md-12 mb-4'>
                            <div className='serviceList'>
                                {servicesData.map((service) => (
                                    <div
                                        key={service.id}
                                        className={`serviceListItem ${activeService === service.id ? 'active' : ''}`}
                                        onClick={() => setActiveService(service.id)}
                                    >
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            <div className="serviceTitle">
                                                <h5>{service.title}</h5>
                                            </div>
                                            <div className='serviceListIcon'>
                                                {service.icon}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='col-lg-8 col-md-12'>
                            <div className='serviceDetailContent'>
                                {activeServiceData && activeServiceData.content}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            <HiringIcon />
            <Footer />
            <GoToTop />
        </div>
    );
}

export default Services;